"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));

var _numeral = _interopRequireDefault(require("numeral"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Utility module for number related helper functions.
 *
 */
var _default = {
  /**
   * Constrains the number between the min and max values.
   *
   * @param {number} num The number to be constrained to.
   * @param {number} min The minimum limit
   * @param {number} max The maximum limit.
   *
   * @returns {number}
   */
  constrain: function constrain(num, min, max) {
    return Math.min(Math.max(num, min), max);
  },
  formatCurrency: function formatCurrency(value, includeCents) {
    var input = value;
    var formatString = '$0,0';
    if (includeCents) formatString += '.00';
    if ((0, _isNaN2["default"])(input)) input = 0;
    return (0, _numeral["default"])(input).format(formatString);
  },
  formatPercent: function formatPercent(input, formatterStr) {
    return (0, _numeral["default"])(input).format(formatterStr || '0.0[00]%');
  },
  value: function value(formattedInput) {
    return (0, _numeral["default"])(formattedInput).value();
  }
};
exports["default"] = _default;